import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseProductsAdapter = getAdapter();

const warehouseProductsSlice = createSlice({
  name: 'warehouseProducts',
  initialState: warehouseProductsAdapter.getInitialState(),
  reducers: {
    setWarehouseProducts: (state, { payload: { warehouseProducts } }) => {
      warehouseProductsAdapter.setAll(state, warehouseProducts);
    },
  },
});

const selectors = warehouseProductsAdapter.getSelectors(({ warehouseProducts }) => warehouseProducts);

export const getWarehouseProducts = (state) => selectors.selectAll(state);

export const {
  setWarehouseProducts,
} = warehouseProductsSlice.actions;

export default warehouseProductsSlice.reducer;